import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import Description from '@mui/icons-material/ViewList';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import CompetenceOrderGeneralDataComponent from './CompetenceOrderGeneralDataComponent';

export const CompetenceOrderGeneralDataCard = ({
  competenceOrder,
  applicationStatuses,
  approvalTypes,
  validation,
  onSave,
  onPropertyChanged
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={Description}
      iconColor='primary'
      title={t('CompetenceOrder.GeneralData')}
      actions={
        <IconButton
          type='save'
          fontSize='medium'
          color='transparent'
          tooltip={t('CompetenceOrder.SaveChanges')}
          onClick={onSave}
          disabled={!competenceOrder.changed}
        />
      }
    >
      <>
        <Prompt when={competenceOrder.changed} message={t('CompetenceOrder.LeavingWithoutSavingCompetenceOrder')} />
        <CompetenceOrderGeneralDataComponent
          competenceOrder={competenceOrder}
          applicationStatuses={applicationStatuses}
          approvalTypes={approvalTypes}
          validation={validation}
          onPropertyChanged={onPropertyChanged}
        />
      </>
    </Card>
  );
};

CompetenceOrderGeneralDataCard.propTypes = {
  competenceOrder: PropTypes.object.isRequired,
  applicationStatuses: PropTypes.array.isRequired,
  approvalTypes: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired
};

export default CompetenceOrderGeneralDataCard;
